import React, { useRef, useEffect } from 'react';
import { Checkbox } from '../form/checkbox';

export const IndeterminateCheckbox = React.forwardRef<
  HTMLInputElement,
  {
    indeterminate: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    checked?: boolean;
  }
>(({ indeterminate, checked, ...rest }, ref) => {
  const defaultRef = useRef<HTMLInputElement>();
  const resolvedRef = (ref || defaultRef) as React.RefObject<HTMLInputElement>;

  useEffect(() => {
    if (resolvedRef?.current?.indeterminate) {
      resolvedRef.current.indeterminate = indeterminate;
    }
  }, [resolvedRef, indeterminate]);

  return (
    <Checkbox
      ref={resolvedRef}
      {...rest}
      isChecked={!!checked}
    />
  );
});
